import { slideUp, slideDown } from "./slide";

/**
 * mixin accordion とセットで使用
 */

export const accordion = (options = {}) => {
  const accordions = document.querySelectorAll(".js-accordion");
  const externalTriggers = document.querySelectorAll(".js-accordion-trigger");

  const state = new Map();
  const defaultState = {
    isActive: false,
    triggers: [],
    content: null,
  };

  const toggleAccordion = (element) => {
    const currentState = state.get(element) || { ...defaultState };
    const isActive = !currentState.isActive;
    // スライドアニメーション
    isActive ? slideDown(currentState.content) : slideUp(currentState.content);
    console.log("🚀 ~ toggleAccordion ~ isActive:", isActive);

    // クラスの切り替え
    element.classList.toggle("is-active", isActive);

    currentState.triggers.forEach((element) => {
      element.setAttribute("aria-expanded", String(isActive));
      element.classList.toggle("is-active", isActive);
    });

    currentState.isActive = isActive;
  };

  const setupAccordion = (element) => {
    const currentState = state.get(element) || { ...defaultState };
    state.set(element, currentState);

    const header = element.querySelector("[data-accordion-header]");
    const content = element.querySelector("[data-accordion-content]");

    if (!header || !content) {
      console.error("Accordion header or content not found", element);
      return;
    }

    currentState.isActive = element.classList.contains("is-active");
    currentState.triggers = [...currentState.triggers, header];
    currentState.content = content;

    if (!currentState.isActive) {
      slideUp(currentState.content, 0);
    }

    const handler = () => toggleAccordion(element);
    header.addEventListener("click", handler);
    currentState.removeListener = () =>
      header.removeEventListener("click", handler);
  };

  const setupAccordionTriggers = (element) => {
    const targetName = element.dataset.accordionTarget;
    const target = document.querySelector(
      `[data-accordion-name=${targetName}]`
    );

    if (!target) {
      console.error("Accordion target not found", element);
      return;
    }

    const currentState = state.get(target) || { ...defaultState };
    state.set(target, currentState);
    currentState.isActive = target.classList.contains("is-active");
    currentState.triggers = [...currentState.triggers, element];
    currentState.content = target;

    if (!currentState.isActive) {
      slideUp(currentState.content, 0);
    }

    const handler = () => toggleAccordion(target);
    element.addEventListener("click", handler);
    currentState.removeListener = () =>
      element.removeEventListener("click", handler);
  };

  accordions.forEach(setupAccordion);
  externalTriggers.forEach(setupAccordionTriggers);

  return {
    destroy: () => {
      state.forEach((currentState) => {
        if (currentState.removeListener) {
          currentState.removeListener();
        }
      });
      state.clear();
    },
  };
};
